<script lang="ts">
    import type { TranslationNamespaces } from "@apps/rewards/types";
    import type ClipboardInterface from "@lib/DOMClipboardAdapter/ClipboardInterface";
    import DOMClipboardAdapter from "@lib/DOMClipboardAdapter/DOMClipboardAdapter";
    import { fade } from "svelte/transition";

    import T from "@components/T.svelte";
    import Text from "@components/Typography/Text.svelte";

    import RewardsIconButton from "./RewardsIconButton.svelte";

    //Props
    export let value: string;
    export let namespace: TranslationNamespaces;
    export let ariaLabel: string;

    //Variables
    const clipboard: ClipboardInterface = new DOMClipboardAdapter();
    let isCopied = false;

    //Handlers
    const handleCopy = () => {
        clipboard.writeText(value);
        isCopied = true;

        setTimeout(() => (isCopied = false), 1500);
    };
</script>

<RewardsIconButton on:click={handleCopy} {ariaLabel}>
    {#if isCopied}
        <div transition:fade={{ duration: 200 }} class="gw-rd-copy-icon-btn">
            <Text variant="secondary" component="span" size="sm">
                <T {namespace} translationKey="copied_label" />
            </Text>
        </div>
    {/if}
    <slot />
</RewardsIconButton>

<style lang="postcss">
    .gw-rd-copy-icon-btn {
        position: absolute;
        top: -35px;
        left: 50%;
        z-index: 2;
        width: max-content;
        transform: translateX(-50%);
        padding: var(--gw-rd-space-2) var(--gw-rd-space-4);
        box-shadow: 0px 3px 6px -3px rgba(23, 24, 24, 0.08),
            0px 8px 20px -4px rgba(23, 24, 24, 0.12);
        background-color: var(--gw-rd-white-color);
        border-radius: var(--gw-rd-border-radius-xs);
    }
</style>
